module.exports = __webpack_public_path__ + "img/maisonier.a145b297.svg";